import { Popover } from "antd-mobile"
import styled from "styled-components"

export const StyledFoodDetails = styled.div`
  height: 100%;
  width: 100%;
  position: relative;

  .image-viewer-mask {
    background: #404040 !important;
  }
`

export const FoodDetailsHeader = styled.div`
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  justify-content: space-between;
  padding: 0 var(--app-horizontal-padding);

  svg {
    cursor: pointer;
  }
`

export const FoodDetailsContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const FoodDetailsBody = styled.div`
  overflow-y: auto;
  height: calc(100% - var(--app-cta-height));
`

export const FoodDetailsInfo = styled.div`
  padding: var(--app-horizontal-padding);
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`

export const IngredientList = styled.div`
`

export const IngredientListTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  margin-bottom: 8px;
`

export const FoodDetailsPopover = styled(Popover.Menu)`
  --arrow-size: 0px;

  .adm-popover-menu-list-inner {
    padding: 4px 0px;
  }

  .adm-popover-menu-item {
    svg {
      width: 16px;
      height: 16px;
    }

    padding-left: 0px;
    width: 173px;

    &:first-child {
      .adm-popover-menu-item-text {
        border-top: none;
      }
    }

    &:last-child {
      color: var(--Schemes-On-Error-Container, #ff4921);
    }

    .adm-popover-menu-item-text {
      padding: 8px 12px;
      line-height: 22px;
      font-weight: 600;
      font-size: 14px;
    }
  }
`
